import React, { useEffect } from "react";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import {
    Create,
    SimpleForm,
    TextInput,
    DateInput,
} from "react-admin";
import { useForm, useFormState } from "react-final-form";

import { USER_GROUP_ADMIN } from "../../utils/const";
import { _clientUserStorage } from "../../utils/storage";
import { _arrayUserGroup } from "../../utils/enum";

const useStyles = makeStyles((theme) => ({
    form: {
        width: "100%",
        "& > div > div > div:first-child": {
            width: "100%",
        },
    },
}));

const CreateComponent = (props) => {
    const classes = useStyles();
    return (
        <Create {...props} title="Create">
            <SimpleForm className={classes.form} redirect={"list"}>
                <Grid container spacing={3}>
                    <Grid item sm={12}>
                        <DateInput label="Date" source="date" fullWidth />
                    </Grid>
                    <Grid item sm={12}>
                        <TextInput label="Messages" source="messages" multiline rows={4} fullWidth />
                    </Grid>
                </Grid>

            </SimpleForm>
        </Create>
    );
};

export default CreateComponent;
